var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{
      extendTreeType:this.$route.query.IS_TREE==1?2:0,
    },"option":{
      extendTreeType:this.$route.query.IS_TREE,
    },"colObj":{
      opId:"3122",
      name:"标签明细",
      parentId:"LABELDEF_ID",
      parentName:"标签定义",
      parentPath:"/system/labelDefine",
      dataClass:2,
      isTree:_vm.isTree,
      addParams:{
        LABELDEF_ID:this.$route.query.LABELDEF_ID,
      },
      col:[],
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }